export default __webpack_public_path__ + "static/media/fred-benj-products.f73fdea2.png";